// extracted by mini-css-extract-plugin
module.exports = {"container":"TopBox-module__container--2YBI3","fartherLogo":"TopBox-module__fartherLogo--2xSRE"};